import { useState, useEffect } from "react";

const KEY = "GS_LANG";

export function getLang() {
  if (typeof window === "undefined") return "fr";
  return localStorage.getItem(KEY) || "fr";
}

// Hook: renvoie [lang, setLang]. La langue est persistée et synchronisée
// entre les composants via un évènement custom.
export function useLang() {
  const [lang, setLangState] = useState(getLang());

  useEffect(() => {
    const handler = () => setLangState(getLang());
    window.addEventListener("gs-lang", handler);
    return () => window.removeEventListener("gs-lang", handler);
  }, []);

  const setLang = (l) => {
    localStorage.setItem(KEY, l);
    window.dispatchEvent(new Event("gs-lang"));
  };

  return [lang, setLang];
}

const wrap = {
  position: "fixed",
  top: 14,
  right: 14,
  zIndex: 300,
  display: "flex",
  alignItems: "center",
  gap: 6,
  fontFamily: '"IBM Plex Mono", "Courier New", monospace',
  fontSize: 12,
};

const btn = (active) => ({
  background: "transparent",
  border: "none",
  padding: 0,
  cursor: "pointer",
  fontFamily: "inherit",
  fontSize: 12,
  color: "#111",
  opacity: active ? 1 : 0.45,
  textDecoration: active ? "underline" : "none",
});

export function LangToggle() {
  const [lang, setLang] = useLang();
  return (
    <div style={wrap} className="langToggle">
      <button
        className="langToggle__btn"
        style={btn(lang === "en")}
        onClick={() => setLang("en")}
      >
        EN
      </button>
      <span style={{ opacity: 0.35 }}>/</span>
      <button
        className="langToggle__btn"
        style={btn(lang === "fr")}
        onClick={() => setLang("fr")}
      >
        FR
      </button>
    </div>
  );
}
